import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        modalContent: {
            w: {base: '100vw', lg: '95vw'},
            maxW: {base: '100vw', lg: '95vw'},
            h: {base: '100vh', lg: '80vh'},
            maxH: {base: '100vh', lg: '80vh'},
            m: remCalc(0),
            borderRadius: remCalc(0),
        },
        modalBody: {
            h: '100%',
            p: remCalc(0),
        },
        outerHstack: {
            alignItems: 'stretch',
            justifyContent: 'center',
            h: '100%',
        },
        mobileContainer: {
            gap: remCalc(8),
            h: '100%',
        },
        resultsContainer: {
            overflowY: 'scroll',
            gap: {base: remCalc(8), lg: remCalc(16)},
            padding: {base: remCalc(16), lg: remCalc(0)},
        },
        leftColumn: {
            flex: 1,
        },
        rightColumn: {
            maxH: '100%',
            h: '100%',
            maxW: remCalc(470),
            w: '100%',
            padding: remCalc(24),
            gap: remCalc(16),
        },
        mapContainer: {
            h: {base: remCalc(278), lg: '100%'},
            minH: remCalc(278),
            w: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        modalHeaderContainer: {
            flexDirection: 'row',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingBottom: {base: remCalc(16), lg: remCalc(24)},
            paddingTop: {base: remCalc(16), lg: remCalc(0)},
            paddingX: {base: remCalc(16), lg: remCalc(0)},
            borderBottom: '1px solid',
            borderColor: 'border.light',
        },
        modalHeaderText: {
            textStyle: 'body-large',
            fontWeight: 'bold',
            textColor: 'text.default',
        },
        modalCloseButton: {
            boxSize: 'iconsSize.medium',
        },
        searchBarContainer: {
            w: '100%',
            paddingY: remCalc(8),
            paddingX: {base: remCalc(16), lg: remCalc(0)},
        },
    },
}
